<template>
  <div :class="textColorClass" class="policy-links o-caption py-4 px-2 md:px-0">
    <ul class="grid grid-cols-2 md:flex md:flex-row justify-center items-center mb-0">
      <li v-for="(link, index) in policyLinks" :key="link.text" :class="`py-2 md:py-0 text-center`">
        <a
          :href="link.href"
          target="_blank"
          class="hover:text-blue-600 hover:underline transition-colors duration-200 md:py-1 text-xss"
        >
          {{ link.text }}
        </a>
        <span
          v-if="index < policyLinks.length - 1"
          class="hidden md:inline mx-2 text-gray-400"
        >
          -
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PolicyLinks',
  props: {
    textColorClass: {
      type: String,
      default: 'text-gray-500 md:text-gray-600'
    }
  },
  computed: {
    policyLinks () {
      return [
        { text: this.$t('Footer.TermsConditions'), href: `/${this.locale}-${this.country}${this.$t('FooterLinks.TermsConditions')}` },
        { text: this.$t('Footer.TermsOfUse'), href: `/${this.locale}-${this.country}${this.$t('FooterLinks.TermsOfUse')}` },
        { text: this.$t('Footer.Privacy'), href: `/${this.locale}-${this.country}${this.$t('FooterLinks.Privacy')}` },
        { text: this.$t('Footer.CookieDeclaration'), href: `/${this.locale}-${this.country}/cookie-declaration` }
      ]
    },
    ...mapState('app', {
      locale: state => state.locale,
      country: state => state.country
    })
  }
}
</script>

<style scoped lang="postcss">
.policy-links {
  max-width: 33rem;
  @apply mx-auto;

  .text-xss {
    font-size: 9px;
  }
}

@screen md {
  .policy-links {
    max-width: unset;

    .text-xss {
      font-size: 12px;
    }
  }
}
</style>
